let GameState:any = {
    posicaoBranca: {x: -1, y: 9, z: -1},
    horizontalSpeed: 10.0 / 360,
    verticalSpeed: 10.0 / 360,
    cameraDistance: 10
};

export default GameState;